import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Form,
} from "reactstrap";
import ParticlesAuth from "./particlesAuth";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import logoLight from "../../assets/logo/shivlogo.png";
import { login } from "../../api/loginApi";
import { AuthLabels } from "../../common/constant/Authentication";
import { checkStatusCodeSuccess, errorHandler } from "../../utils/helpers/common";
import { emailRegex, InputPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseInput from "../../components/BaseComponents/BaseInput";

const Login = (props) => {
  document.title = AuthLabels.Login;
  const history = useNavigate();
  const [passwordShow, setPasswordShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required(validationMessages.required(AuthLabels.Email))
        .matches(emailRegex, validationMessages.format(AuthLabels.Email)),
      password: Yup.string().required(
        validationMessages.required(AuthLabels.Password)
      ),
    }),
    onSubmit: (values) => {
      setIsLoading(true);
      login(values)
        .then((response) => {
          if (checkStatusCodeSuccess(response?.statusCode)) {
            history("/");
            toast.success(response?.message);
          } else {
            toast.error(response?.message);
          }
        })
        .catch((err) => {
          errorHandler(err);
        })
        .finally(() => setIsLoading(false));
    },
  });

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" height="30" />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Welcome Back !</h5>
                  </div>

                  <div className="p-2 mt-4">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <BaseInput
                          name="email"
                          type="email"
                          placeholder={InputPlaceHolder(AuthLabels.Email)}
                          onChange={validation.handleChange}
                          handleBlur={validation.handleBlur}
                          value={validation.values.email}
                          touched={validation.touched.email}
                          error={validation.errors.email}
                          label={AuthLabels.Email}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <div className="float-end">
                          <Link to="/forgot-password" className="text-muted">
                            Forgot password?
                          </Link>
                        </div>
                        <div className="form-group">
                          <BaseInput
                            className="form-control"
                            name="password"
                            type="password"
                            placeholder={InputPlaceHolder(AuthLabels.Password)}
                            label={AuthLabels.Password}
                            onChange={validation.handleChange}
                            handleBlur={validation.handleBlur}
                            value={validation.values.password}
                            touched={validation.touched.password}
                            error={validation.errors.password}
                            required
                          />
                        </div>
                      </div>
                      <div className="mt-4">
                        <Row>
                          <Col>
                            <BaseButton
                              color="success"
                              type="submit"
                              label={AuthLabels.Login}
                              loader={isLoading}
                              className="w-100"
                            />
                          </Col>
                        </Row>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

export default Login;
